import React from "react";
import Loader from "../../../../components/Loader";
import Pagination from "../../../../components/Pagination";
import { useSemenOwnershipCertificateRequests } from "../hooks/useSemenOwnershipCertificateRequests";
import SemenOwnershipFilter from "../Components/SemenOwnershipFilter";
import SemenOwnershipTable from "../Components/SemenOwnershipTable";

/**
 * Semen Ownership Certificate Requests Page
 * Embedded tab inside OwnerProfile.
 * Adheres strictly to EAHS shared components and design system.
 */
export default function SemenOwnershipCertificateRequestsPage() {
    const {
        doses,
        loading,
        currentPage,
        totalPages,
        isLastPage,
        searchTerm,
        selectedStatus,
        handleSearchChange,
        handleSearchSubmit,
        handleStatusChange,
        goToPage,
    } = useSemenOwnershipCertificateRequests();

    return (
        <>
            {/* Search and Status Filter */}
            <SemenOwnershipFilter
                searchTerm={searchTerm}
                selectedStatus={selectedStatus}
                onSearchChange={handleSearchChange}
                onStatusChange={handleStatusChange}
                onSearchSubmit={handleSearchSubmit}
            />

            {/* Loading Indicator */}
            {loading && <Loader />}

            {/* Table */}
            {!loading && <SemenOwnershipTable doses={doses} />}

            {/* Shared Pagination */}
            {!loading && (
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    isLastPage={isLastPage}
                    onPageChange={goToPage}
                />
            )}
        </>
    );
}
